import {sdk} from '../components/sdk.js';
import {sdkLocal} from '../components/sdkLocal.js';

import 'bootstrap/dist/css/bootstrap.min.css'
import React, { useState, useEffect, useMemo, useRef } from 'react';
import '../../components/PeupleQcRoot.css';
import Head from 'next/head';
import Link from 'next/link';
import {PeupleQcWall} from "../../components/PeupleQcWall.js";
import { 
  FaUsers, 
  FaComments, 
  FaBuilding, 
  FaBriefcase, 
  FaGift, 
  FaGamepad,
  FaUserPlus,
  FaSignInAlt,
  FaStar,
  FaStarHalfAlt
} from 'react-icons/fa';

export async function getServerSideProps(context) {
    return {
        props: {
        }
    }
}

export default function PeupleQcRoot({}) {

  const [user, setUser] = useState(null);

  useEffect(()=>{
    async function fetchUser() {
        var myself = await sdk.models.PeupleUser.getMySelf({});
        if (typeof myself !== "undefined" && myself !== null && typeof myself.error === "undefined") {
            setUser(myself);
            localStorage.setItem("myself", JSON.stringify(myself));
        }
    }
    var token = localStorage.getItem("liberium-token");
    if (token !== null) {
        var mine = localStorage.getItem("myself");
        if (mine !== null) {
            setUser(JSON.parse(mine));
        } else {
            fetchUser();
        }
    }
  },[])

  const getMobileOperatingSystem = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  };

  const handleSignupClick = (e) => {
    e.preventDefault();
    const os = getMobileOperatingSystem();
    if (os === "iOS") {
      window.location.replace("itms-apps://itunes.apple.com/app/id6502412584");
    } else if (os === "Android") {
      window.location.replace("market://details?id=com.peupleqc.app");
    } else {
      window.location.href = "/signup";
    }
  };

  return (
    <>
      <Head>
        <title>Peuple Qc : Le 1er réseau social du Québec</title>
        <meta name="description" content={"Nous sommes le 1er réseau social du Québec" }/>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/favicon.ico" />
        <meta name="bitmedia-site-verification" content="fd4fff6a6f668f252d4eb49ebed41ed0" />   
      </Head>
      <>      
      {user===null &&
        <section className="pqr-hero-section">
          <div className="pqr-container">
            <div className="pqr-hero-content">
              <img
                src={'https://peupleqc.com/s/liberium-public-img/peuple_qc_ico_transparent.png'}
                alt="Logo Peuple Qc"
                className="pqr-logo"
              />
              
              <h1 className="pqr-main-title">Bienvenue sur Peuple Qc!</h1>
              <p className="pqr-subtitle">Le 1er réseau social 100% québécois</p>
              
              <div className="pqr-rating-section">
                <div className="pqr-stars">
                  <FaStar className="pqr-star" />
                  <FaStar className="pqr-star" />
                  <FaStar className="pqr-star" />
                  <FaStar className="pqr-star" />
                  <FaStarHalfAlt className="pqr-star" />
                </div>
                <p className="pqr-rating-text">"Enfin du Québécois!!!"</p>
              </div>
              
              <div className="pqr-cta-buttons">
                <div className="pqr-cta-primary" onClick={handleSignupClick}>
                  <FaUserPlus />
                  S'enregistrer gratuitement
                </div>
                <Link href="/login" className="pqr-cta-secondary">
                  <FaSignInAlt />
                  Se connecter
                </Link>
              </div>
            </div>

            <div className="pqr-features-grid">
              <div className="pqr-feature-card">
                <div className="pqr-feature-icon">
                  <FaUsers />
                </div>
                <h3 className="pqr-feature-title">Groupes de discussion</h3>
                <p className="pqr-feature-description">
                  Rejoignez des communautés passionnées et participez à des discussions enrichissantes sur tous les sujets qui vous intéressent.
                </p>
              </div>

              <div className="pqr-feature-card">
                <div className="pqr-feature-icon">
                  <FaComments />
                </div>
                <h3 className="pqr-feature-title">Messagerie privée</h3>
                <p className="pqr-feature-description">
                  Échangez en privé avec vos contacts grâce à notre système de messagerie sécurisé et facile à utiliser.
                </p>
              </div>

              <div className="pqr-feature-card">
                <div className="pqr-feature-icon">
                  <FaBuilding />
                </div>
                <h3 className="pqr-feature-title">Pages d'entreprise</h3>
                <p className="pqr-feature-description">
                  Créez une présence professionnelle pour votre entreprise. 
                  <Link href="/marque" className="pqr-feature-link"> Découvrez nos solutions pour les marques</Link>.
                </p>
              </div>

              <div className="pqr-feature-card">
                <div className="pqr-feature-icon">
                  <FaBriefcase />
                </div>
                <h3 className="pqr-feature-title">Trouver des talents</h3>
                <p className="pqr-feature-description">
                  Connectez-vous avec des travailleurs compétents dans différents domaines et développez votre réseau professionnel.
                </p>
              </div>

              <div className="pqr-feature-card">
                <div className="pqr-feature-icon">
                  <FaGift />
                </div>
                <h3 className="pqr-feature-title">Cadeaux & récompenses</h3>
                <p className="pqr-feature-description">
                  Participez à nos concours et gagnez des prix exclusifs réservés à notre communauté québécoise.
                </p>
              </div>

              <div className="pqr-feature-card">
                <div className="pqr-feature-icon">
                  <FaGamepad />
                </div>
                <h3 className="pqr-feature-title">Jeux & divertissement</h3>
                <p className="pqr-feature-description">
                  Amusez-vous avec nos jeux intégrés et défiez vos amis dans une ambiance conviviale et québécoise.
                </p>
              </div>
            </div>
          </div>
        </section>
      }
      {user !== null &&
        <PeupleQcWall
            user={user}
        />
      }      
    </>
  </>
  )
}